import { Component, Input, OnInit } from '@angular/core';
import { IApplicationFeature } from '@carm/_utils/models';

@Component({
  selector: 'carm-index-page',
  templateUrl: './index-page.component.html',
  styleUrls: ['./index-page.component.scss'],
})
export class IndexPageComponent implements OnInit {

  @Input()
  inCmsContentPageId: string;

  @Input()
  inIndexPage: IApplicationFeature;

  @Input()
  inBreadcrumbLevels: string;

  @Input()
  hideTopTitleInfo: boolean;

  @Input()
  inColumnNumber: number;
  
  @Input()
  inIValue: number;


  columnValue = 4;
  iValue = 3;

  constructor() { }

  ngOnInit(): void {
    if (this.inColumnNumber !== undefined) {
      this.columnValue = this.inColumnNumber
    }

    if(this.inIValue !== undefined) {
      this.iValue = this.inIValue
    }
  }



}
